<template>
  <div class="kpi-data-chart-page" v-if="true">
    <div class="data-summary">
      <div class="tip bottom-line">
        数据总览
        <span class="activity_name">{{activityName}}</span>
      </div>
      <div class="f datachartitem bottom-line">
        <span>
          <!-- <div class="num">{{statistics.view_num}}</div> -->
          <div class="num">{{actData.viewNum}}</div>
          <div class="grey">浏览客户数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.fission_num}}</div> -->
          <div class="num">{{actData.fissionNum}}</div>
          <div class="grey">裂变客户数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.enrollment_num}}</div> -->
          <div class="num">{{actData.enrollmentNum}}</div>
          <div class="grey">报名客户数</div>
        </span>
      </div>
      <div class="f datachartitem bottom-line">
        <span>
          <!-- <div class="num">{{statistics.card_num}}</div> -->
          <div class="num">{{actData.cardNum}}</div>
          <div class="grey">售卡客户数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.thumb_num}}</div> -->
          <div class="num">{{actData.seckillUserNum}}</div>
          <div class="grey">秒杀客户数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.order_num}}</div> -->
          <div class="num">{{actData.thumbNum}}</div>
          <div class="grey">集赞客户数</div>
        </span>
      </div>
      <div class="f datachartitem bottom-line">
        <span>
          <!-- <div class="num">{{statistics.devote_order_num}}</div> -->
          <div class="num">{{actData.liveViewNum}}</div>
          <div class="grey">进入直播间客户数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.live_visit_num}}</div> -->
          <div class="num">{{actData.liveOrderCusNum}}</div>
          <div class="grey">直播下订客户数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.live_order_num}}</div> -->
          <div class="num">{{actData.liveSelfOrderNum}}</div>
          <div class="grey">直播自签单数</div>
        </span>
      </div>
      <div class="f datachartitem bottom-line">
        <span>
          <!-- <div class="num">{{statistics.devote_order_num}}</div> -->
          <div class="num">{{actData.liveOtherOrderNum}}</div>
          <div class="grey">直播贡献单数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.live_visit_num}}</div> -->
          <div class="num">{{actData.liveSelfOrderChangeNum}}</div>
          <div class="grey">直播自签转单数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.live_order_num}}</div> -->
          <div class="num">{{actData.liveOtherOrderChangeNum}}</div>
          <div class="grey">直播贡献转单数</div>
        </span>
      </div>
      <div class="f datachartitem bottom-line">
        <span>
          <!-- <div class="num">{{statistics.devote_order_num}}</div> -->
          <div class="num">{{actData.processSelfOrderNum}}</div>
          <div class="grey">过程自签单数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.live_visit_num}}</div> -->
          <div class="num">{{actData.processDevoteOrderNum}}</div>
          <div class="grey">过程贡献单数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.live_order_num}}</div> -->
          <div class="num">{{actData.liveOtherOrderChangeNum}}</div>
          <div class="grey">直播贡献转单数</div>
        </span>
      </div>
      <div class="f datachartitem bottom-line">
        <span>
          <div class="num">{{actData.appointmentNum}}</div>
          <div class="grey">直播预约客户</div>
        </span>
      </div>
    </div>

    <div class="data-average">
      <div class="tip bottom-line">人均数据</div>
      <div class="f datachartitem bottom-line">
        <span>
          <!-- <div class="num">{{statistics.avg_view_num}}</div> -->
          <div class="num">{{avgActData.viewNum}}</div>
          <div class="grey">浏览客户数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.avg_fission_num}}</div> -->
          <div class="num">{{avgActData.fissionNum}}</div>
          <div class="grey">裂变客户数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.avg_enrollment_num}}</div> -->
          <div class="num">{{avgActData.enrollmentNum}}</div>
          <div class="grey">报名客户数</div>
        </span>
      </div>
      <div class="f datachartitem bottom-line">
        <span>
          <!-- <div class="num">{{statistics.avg_card_num}}</div> -->
          <div class="num">{{avgActData.cardNum}}</div>
          <div class="grey">售卡客户数</div>
        </span>
        <span class="border">
          <!-- <div class="num">{{statistics.avg_thumb_num}}</div> -->
          <div class="num">{{avgActData.seckillUserNum}}</div>
          <div class="grey">秒杀客户数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.avg_order_num}}</div> -->
          <div class="num">{{avgActData.thumbNum}}</div>
          <div class="grey">集赞客户数</div>
        </span>
      </div>
      <div class="f datachartitem bottom-line">
        <span>
          <!-- <div class="num">{{statistics.avg_devote_order_num}}</div> -->
          <div class="num">{{avgActData.liveViewNum}}</div>
          <div class="grey">进入直播间客户数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.avg_live_visit_num}}</div> -->
          <div class="num">{{avgActData.liveOrderCusNum}}</div>
          <div class="grey">直播下订客户数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.avg_live_order_num}}</div> -->
          <div class="num">{{avgActData.liveSelfOrderNum}}</div>
          <div class="grey">直播自签单数</div>
        </span>
      </div>
      <div class="f datachartitem bottom-line">
        <span>
          <!-- <div class="num">{{statistics.avg_devote_order_num}}</div> -->
          <div class="num">{{avgActData.liveOtherOrderNum}}</div>
          <div class="grey">直播贡献单数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.avg_live_visit_num}}</div> -->
          <div class="num">{{avgActData.liveSelfOrderChangeNum}}</div>
          <div class="grey">直播自签转单数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.avg_live_order_num}}</div> -->
          <div class="num">{{avgActData.liveOtherOrderChangeNum}}</div>
          <div class="grey">直播贡献转单数</div>
        </span>
      </div>
      <div class="f datachartitem bottom-line">
        <span>
          <!-- <div class="num">{{statistics.avg_devote_order_num}}</div> -->
          <div class="num">{{avgActData.processSelfOrderNum}}</div>
          <div class="grey">过程自签单数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.avg_live_visit_num}}</div> -->
          <div class="num">{{avgActData.processDevoteOrderNum}}</div>
          <div class="grey">过程贡献单数</div>
        </span>
        <span>
          <!-- <div class="num">{{statistics.avg_live_order_num}}</div> -->
          <div class="num">{{avgActData.liveOtherOrderChangeNum}}</div>
          <div class="grey">直播贡献转单数</div>
        </span>
      </div>
      <div class="f datachartitem bottom-line">
        <span>
          <div class="num">{{avgActData.appointmentNum}}</div>
          <div class="grey">直播预约客户</div>
        </span>
      </div>
    </div>

    <div class="home-over-btn">
      <router-link :to="{ name: 'kpi.home',query: { act_id: act_id}}">
        <img src="https://j.weizan.cn/youxiang/images/home-over.png" />
        首页
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      // activity: this.settings.activity,
      // user_id: this.$route.query.user_id,
      // kpi_uid: this.$route.query.kpi_uid,
      // share_uid: this.$route.query.share_uid,
      user: null,
      kpi_user: null,
      chartPie: null,
      kpi: [],
      title: [],
      statistics: null,
      activityName: "活动名称",
      actData: {
        actSignNum: 0,
        appointmentNum: 0,
        cardNum: 0,
        enrollmentNum: 0,
        fissionNum: 0,
        goShopNum: 0,
        liveOrderCusNum: 0,
        liveOtherOrderChangeNum: 0,
        liveOtherOrderNum: 0,
        liveSelfOrderChangeNum: 0,
        liveSelfOrderNum: 0,
        liveViewNum: 0,
        processDevoteOrderNum: 0,
        processSelfOrderNum: 0,
        seckillOrderNum: 0,
        seckillUserNum: 0,
        shareNum: 0,
        thumbNum: 0,
        viewNum: 0,
      },
      avgActData: {
        actSignNum: 0,
        appointmentNum: 0,
        cardNum: 0,
        enrollmentNum: 0,
        fissionNum: 0,
        goShopNum: 0,
        liveOrderCusNum: 0,
        liveOtherOrderChangeNum: 0,
        liveOtherOrderNum: 0,
        liveSelfOrderChangeNum: 0,
        liveSelfOrderNum: 0,
        liveViewNum: 0,
        processDevoteOrderNum: 0,
        processSelfOrderNum: 0,
        seckillOrderNum: 0,
        seckillUserNum: 0,
        shareNum: 0,
        thumbNum: 0,
        viewNum: 0,
      },
    };
  },
  methods: {
    async getActInfo() {
      let res = await this.$http.post("/v1/home/activity");
      console.log(res);
      this.activityName = res.data.actName;
    },
    // 活动负责人获取活动数据
    async getActData() {
      let res = await this.$http.post(
        "/v1/home/act_data/get_act_data_ana_act_id"
      );
      console.log(res, 1231313);
      if (res.data && res.code == 0) {
        this.actData = res.data.actData;
        this.avgActData = res.data.avgActData;
      }
    },
  },
  created() {
    this.act_id = this.$route.query.act_id || localStorage.getItem("act_id");
    this.getActInfo();
    this.getActData();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
};
</script>

<style lang="less" scoped>
.kpi-data-chart-page {
  // height: calc(100ch);
  padding: 0 13px;
  background-color: #ffffff;
  overflow: hidden;
  .tip {
    padding: 10px 0 10px 15px;
    font-size: 16px;
  }
  .tip:before {
    content: "";
    position: absolute;
    top: 10px;
    left: 0px;
    width: 5px;
    height: 20px;
    background-color: #5293fd;
  }

  .num {
    color: #ffb555;
  }
  .grey {
    color: #999999;
    font-size: 13px;
  }

  .data-summary,
  .data-average {
    border-bottom: 5px solid #ebedf0;
  }
  .activity_name {
    color: #999999;
    margin-left: 10px;
    font-size: 13px;
  }
  .datachartitem {
    padding: 8px 0;
    span {
      text-align: center;
      width: 33.33%;
      border-right: 1px solid #ebedf0;
      line-height: 22px;
    }
    span:last-child {
      border: none;
    }
    .border {
      border-right: 1px solid #ebedf0 !important;
    }
  }

  .chart-container {
    width: 100%;
    height: 100%;
    padding-top: 10px;
    #chartPie {
      width: 100%;
      height: 100%;
    }
  }
  .el-col {
    padding: 30px 20px;
  }
}
</style>